import React from "react";
import AdminLayout from "../../components/layouts/AdminLayout";

function Clients() {
  return (
    <AdminLayout>
      <h3>Clients</h3>
      <hr></hr>
    </AdminLayout>
  );
}

export default Clients;
